var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoNotificacaoOff01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    d: "M18,35.5c-2.9,0-5.2-2.3-5.3-5.2c0,0,0,0,0,0H4c-0.2,0-0.3,0-0.5-0.1h0h0c0,0,0,0,0,0c0,0,0,0,0,0 C3.2,30.1,3,30,2.8,29.8l0,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.2-0.3c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1l0,0l0,0 c-0.1-0.2-0.1-0.4-0.2-0.6c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.2,0-0.4,0.1-0.6L4,23v-5c0-2,0.3-4,0.9-5.9L7.7,15c-0.2,1-0.3,2-0.3,3v5.5 L7,24.9l-0.6,1.8h13.1l3.7,3.7C23.1,33.3,20.8,35.5,18,35.5z M32.5,35L32.5,35L1,3.5L3.5,1l5.1,5.1c1.7-1.7,3.9-2.9,6.3-3.5 c0.8-1.8,2.8-2.6,4.6-1.8c0.8,0.4,1.5,1,1.8,1.8c3.2,0.7,6,2.6,7.8,5.2c2,3,3.1,6.5,3,10.2v5l1.7,5c0.1,0.2,0.1,0.4,0.1,0.6 c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.2-0.1,0.4-0.2,0.6c0,0,0,0.1,0,0.1v0l0,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0,0,0,0,0 l0,0c-0.2,0.1-0.3,0.2-0.5,0.3l2.4,2.4L32.5,35z M18,5.7c-2.6-0.1-5.2,0.9-7,2.7l18.3,18.3h0.4L29,24.9l-0.5-1.4V18 C28.5,10.6,24.4,5.7,18,5.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificacaoOff01);
export default __webpack_public_path__ + "static/media/ico-notificacao-off-01.51487432eadf5fada2b392aae8eea488.svg";
export { ForwardRef as ReactComponent };